import { Record } from 'immutable';

const InitialState = new Record({
  test: true
});

export const initialState = new InitialState();

export default (state = initialState, { type }) => {
  switch (type) {
    default: {
      return state;
    }
  }
};
